export class LinkRequest {
    ResourceId: number;
    TargetId: number;
    Type: string;
}